module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/favicon-b071560ba5dee7d3a00d76cbe0fe1905.png";